import { Plans } from '../components/plan/Plans';

export const PlansContainer = Plans;
